// #region Dados mock
let _data = [
  { id: 101, nome: 'Maria Silva', cpf: '123.456.789-01', telefone: '(11) 98765-4321', cargo: 'Cabeleireiro(a)', data_admissao: '2023-01-14', ativo: true, perc_comissao_padrao: 30.0 },
  { id: 102, nome: 'Ana Costa', cpf: '987.654.321-09', telefone: '(11) 87654-3210', cargo: 'Manicure', data_admissao: '2023-03-19', ativo: true, perc_comissao_padrao: 25.0 },
  { id: 103, nome: 'João Santos', cpf: '111.222.333-44', telefone: '(11) 76543-2109', cargo: 'Recepcionista', data_admissao: '2022-11-09', ativo: false, perc_comissao_padrao: 0.0 },
  { id: 104, nome: 'Carla Oliveira', cpf: '555.666.777-88', telefone: '(11) 65432-1098', cargo: 'Esteticista', data_admissao: '2024-01-07', ativo: true, perc_comissao_padrao: 35.0 },
  { id: 105, nome: 'Pedro Lima', cpf: '999.888.777-66', telefone: '(11) 54321-0987', cargo: 'Gerente', data_admissao: '2022-06-14', ativo: true, perc_comissao_padrao: 15.0 },
];
// #endregion

// #region Util
const delay = (ms = 240) => new Promise(r => setTimeout(r, ms));
// #endregion

// #region Métodos CRUD
export async function listAll() { await delay(); return _data.map(f => ({ ...f })); }
export async function getById(id) { await delay(); const found = _data.find(f => f.id === id); return found ? { ...found } : null; }
export async function create(payload) { await delay(); const id = Date.now(); const novo = { id, ativo: true, perc_comissao_padrao: 0, ...payload }; _data = [novo, ..._data]; return { ...novo }; }
export async function update(id, patch) { await delay(); let updated = null; _data = _data.map(f => { if (f.id === id) { updated = { ...f, ...patch }; return updated; } return f; }); return updated ? { ...updated } : null; }
export async function remove(id) { await delay(); _data = _data.filter(f => f.id !== id); return true; }
// #endregion

// #region Export default
const funcionariosApi = { listAll, getById, create, update, remove };
export default funcionariosApi;
// #endregion
